// extracted by mini-css-extract-plugin
export var attachment = "_p0-a";
export var emailContainer = "_p0-4";
export var emailContentPaddedContainer = "_p0-b";
export var emailHeader = "_p0-6";
export var emailIframe = "_p0-3";
export var emailInfoIcon = "_p0-9";
export var emailShortenedSummary = "_p0-e";
export var infoDropdown = "_p0-0";
export var infoRowBoundedContent = "_p0-d";
export var internal = "_p0-5";
export var merchant = "_p0-8";
export var messageInputContainer = "_p0-h";
export var normal = "_p0-7";
export var replyCard = "_p0-f";
export var subtleButton = "_p0-1";
export var subtleButtonIconContainer = "_p0-2";
export var toggleViewRepliesButton = "_p0-c";
export var wrappingText = "_p0-g";